import { http } from '@/lib/http';
import type { APIResponse } from '@/types';

type PostForgotPasswordParams = {
  email: string;
  oemServiceId: number;
};

type PostForgotPasswordResponse = APIResponse<null>;

export const postForgotPassword = async (params: PostForgotPasswordParams) => {
  return await http<PostForgotPasswordResponse>('/user/v1/forgot-password', {
    method: 'POST',
    body: JSON.stringify({
      email: params.email,
      oem_service_id: params.oemServiceId,
    }),
  });
};
